import { render, staticRenderFns } from "./reportrrecieve.vue?vue&type=template&id=50930064&"
import script from "./reportrrecieve.vue?vue&type=script&lang=js&"
export * from "./reportrrecieve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports